<template>
  <div class="the-recipe__container">
    <!-- id article указан в JSON+LD -->
    <main
      id="article"
      class="the-recipe"
      data-jest="main"
    >
      <!-- Шапка в печатной версии -->
      <header
        aria-hidden="true"
        class="the-recipe__print-header"
      >
        <SvgAsset
          :path="recipeLogo"
          class="the-recipe__print-header-ve"
        />
        <SvgAsset
          :path="lhLogo"
          class="the-recipe__print-header-lh"
        />
      </header>

      <!-- Заголовок поста в печатной версии -->
      <p
        aria-hidden="true"
        class="the-recipe__print-title"
        v-html="recipe.title"
      />

      <div class="hrecipe">
        <RecipeCard
          :add-analytics-attribute="true"
          :author="recipe.author"
          :comments-count="recipe.commentsCount"
          :comments-enabled="isShowComments"
          :cooking-time="recipe.totalTime"
          :covers="recipe.image"
          :dislikes="reactionsStore.getDislikes(recipe.id)"
          :expert="recipe.expert"
          :favorite="articlesStore.getArticleFavorite(recipe.id)"
          :folders="foldersStore.$state"
          :is-cooking-time-visible="true"
          :likes="reactionsStore.getLikes(recipe.id)"
          :link-enabled="false"
          :link-to-edit="getEditLinkHref(recipe.id)"
          :reaction-state="reactionsStore.getReactionsState(recipe.id)"
          :scroll-to-comments="true"
          :show-admin-controls-panel="indexStore.isAuthenticatedInWordpress"
          :title="recipe.title"
          :url="recipe.url"
          :user="user"
          :views-count="articlesStore.getViewsCount(recipe.id)"
          :views-loading="getLoadingViews(recipe.id)"
          class="the-recipe__card"
          cover-loading="eager"
          event-position="recipe-top"
          title-tag-name="h1"
          @update-like="onUpdateLike"
          @update-dislike="onUpdateDislike"
          @click-on-restore-button="updateViewsCount(recipe.id)"
          @favorite-delete="
            (favorite) => {
              onFavoriteDelete(favorite, getPostDataForFavoritesMethod(recipe));
            }
          "
          @favorite-create-folder-and-add="
            (nameFolder) =>
              onFavoriteCreateFolderAndAdd(nameFolder, getPostDataForFavoritesMethod(recipe))
          "
          @favorite-create-folder-and-transfer="
            (nameFolder, favorite) =>
              onFavoriteCreateFolderAndTransfer(
                nameFolder,
                favorite,
                getPostDataForFavoritesMethod(recipe),
                false,
              )
          "
          @favorite-transfer-to-folder="
            (favorite, folder) =>
              onFavoriteTransferToFolder(
                favorite,
                folder,
                getPostDataForFavoritesMethod(recipe),
                false,
              )
          "
          @favorite-add-to-folder="
            (folder) => onFavoriteAddToFolder(folder, getPostDataForFavoritesMethod(recipe))
          "
          @favorite-deferred="onFavoriteDeferred"
        />

        <RecipeDescription
          v-if="recipe.excerpt"
          :content="recipe.excerpt"
          class="the-recipe__description"
        />

        <PrintButton class="the-recipe__print-button" />

        <div
          class="the-recipe__content-container"
          @click="checkImageClick"
        >
          <template
            v-for="(item, idx) in recipe.parsedContent"
            :key="item.id"
          >
            <WidgetsRendererContainer
              v-if="
                widgetsStore.currentInsideRecipe.length &&
                (idx === 3 || idx === recipe.parsedContent.length - 1)
              "
              :widgets="widgetsStore.currentInsideRecipe"
              class="the-recipe__widgets-after-third-block"
              recipes-widget-display-type="big-tiles"
            />
            <TheContent :elem="item" />
          </template>
        </div>

        <!-- <CookingSteps -->
        <!--   class="the-recipe__cooking-steps" -->
        <!--   :steps="recipe.parsedInstructions" -->
        <!-- /> -->

        <div class="the-recipe__categories">
          <div class="the-recipe__categories-wrapper">
            <RecipeCategoryLink
              v-for="(item, index) of recipe.breadcrumb"
              :key="item.title + index"
              :link="item.url"
              :text="item.title + (item.own === 'kitchen' ? ' кухня' : '')"
              :class="
                item.own === 'kitchen'
                  ? 'cuisine-type'
                  : item.own === 'sub'
                    ? 'sub-category'
                    : 'category'
              "
              @click-by-category="onCategoryClick(item)"
            />
          </div>
        </div>
      </div>

      <ArticleNote
        :notes="recipeNotes"
        class="the-recipe__notes"
      />

      <!-- Автор в печатной версии -->
      <div
        aria-hidden="true"
        class="the-recipe__author"
      >
        <img
          :src="recipe.author.avatar"
          alt="Фотография автора"
          class="the-recipe__author-avatar"
        />
        <div class="the-recipe__author-name">
          <b>Автор</b>
          <p>{{ recipe.author.name }}</p>
        </div>
      </div>

      <!-- Футер в печатной версии -->
      <footer
        aria-hidden="true"
        class="the-recipe__print-footer"
      >
        &copy; {{ new Date().getFullYear() }} Лайфхакер
      </footer>
    </main>

    <WidgetsRendererContainer
      :widgets="widgetsStore.currentAboveRecipeComments"
      area="Перед_комментариями"
      recipes-widget-display-type="big-tiles"
    />

    <CommentsContainer
      v-if="isShowComments"
      :id="recipe.id"
      class="the-recipe__comments"
    />

    <WidgetsRendererContainer
      :widgets="widgetsStore.currentBelowRecipeComments"
      area="После_комментариев"
      recipes-widget-display-type="big-tiles"
    />

    <FullScreenGallery
      v-if="isGalleryVisible"
      :current-slide="currentImageId"
      :image-urls="imagesSrc"
      :srcset="imagesSrcset"
      @close="closeGallery"
    />
  </div>
</template>

<script lang="ts" setup>
  import FullScreenGallery from '~/components/content/components/FullScreenGallery.vue';
  import TheContent from '~/components/content/TheContent';
  import {
    getContentObject,
    percentageInit,
    type PercentageObject,
    viewedContentPercent,
  } from '~/utils/PercentagePageElement';
  import RecipeCard from '~/components/RecipeCard/RecipeCard.vue';
  import PrintButton from '~/components/old-recipes/PrintButton/PrintButton.vue';
  import ArticleNote, { getArticleNoteProps } from '~/components/ArticleNote.amp.vue';
  import CommentsContainer from '~/containers/CommentsContainer/CommentsContainer.vue';
  import RecipeDescription from '~/components/RecipeDescription.vue';
  import RecipeCategoryLink from '~/components/RecipeCategoryLink.amp.vue';
  import WidgetsRendererContainer from '~/containers/WidgetsRendererContainer.vue';
  import { getEditLinkHref } from '~/utils';
  import { useServiceErrorsStore } from '~/store/errors';
  import { useWidgetsStore } from '~/store/widgets';
  import { useRecipesListWidgetStore } from '~/store/recipesListWidget';
  import { useArticlesStore } from '~/store/articles';
  import { useIndexStore } from '~/store';
  import { useReactionsStore } from '~/store/reactions';
  import { useFoldersStore } from '~/store/folders';
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';
  import lhLogo from '~/assets/images/lh-logo-black.svg';
  import recipeLogo from '~/assets/images/recipe-logo.svg';
  import { useFavorite } from '~/composables/useFavoriteMethods';
  import { useUpdatingViewsCount } from '~/composables/useUpdatingViewsCount';
  import { useLightboxGallery } from '~/composables/useLightboxGallery';
  import { YA_METRIKA_ID_RECIPE } from '~/constants/config';
  import { useRecipeStore } from '~/store/recipe';
  import { useRecipeAnalyticsHead } from '~/domains/head/analytics/services/useRecipeAnalyticsHead';
  import { useSeoHead } from '~/domains/head/seo/services/useSeoHead';
  import { useLastModifiedHead } from '~/domains/head/technical/services/useLastModifiedHead';

  provide('eventName', 'Рецепт');
  definePageMeta({
    layout: 'recipes',
    middleware: 'fetch-recipe-data',
  });

  // Просмотр отправлен.
  // Переменная нужна из-за того что страница обернута в keep-alive и не пересоздается при повторном открытии.
  const watchSend = ref(false);

  const {
    onFavoriteDelete,
    onFavoriteDeferred,
    onFavoriteAddToFolder,
    onFavoriteTransferToFolder,
    onFavoriteCreateFolderAndAdd,
    onFavoriteCreateFolderAndTransfer,
  } = useFavorite();
  const { getLoadingViews, updateViewsCount } = useUpdatingViewsCount();

  const articlesStore = useArticlesStore();
  const foldersStore = useFoldersStore();
  const indexStore = useIndexStore();
  const nuxtApp = useNuxtApp();
  const reactionsStore = useReactionsStore();
  const recipesListWidgetStore = useRecipesListWidgetStore();
  const route = useRoute();
  const serviceErrorsStore = useServiceErrorsStore();
  const widgetsStore = useWidgetsStore();

  const { recipe, recipeData } = useRecipeStore();

  if (!recipeData) {
    throw createError({
      statusCode: 500,
      message: 'No data received from fetch-recipe-data via useRecipeStore',
    });
  }

  useSeoHead(recipeData.seo, { ampLink: true });
  useRecipeAnalyticsHead(recipeData.seo);
  useLastModifiedHead(recipeData.item?.lastModified);

  const {
    imagesSrc,
    closeGallery,
    imagesSrcset,
    currentImageId,
    checkImageClick,
    isGalleryVisible,
  } = useLightboxGallery(recipe.parsedContent);

  const recipeNotes = computed(() =>
    getArticleNoteProps(
      recipeData.meta.source,
      recipeData.meta.coverSource,
      recipeData.meta.customAuthors,
      'Над рецептом работали: ',
      recipeData.meta.adsSource,
      recipeData.item.isAdvertising,
      recipeData.item.isPromo,
      recipeData.item.advertLabel,
    ),
  );

  const isShowComments = computed(
    () => !serviceErrorsStore.recipeCommentsError && !!recipe?.commentsEnabled,
  );

  function percentageSendAnalytics(
    typeCategory: PercentageObject,
    newValue: number,
    eventYm: string,
  ) {
    const { thresholds, key, category } = typeCategory;
    const viewedThresholds = Object.keys(thresholds)
      .map(Number)
      .filter((threshold) => threshold <= newValue && !thresholds[threshold]);

    viewedThresholds.forEach((threshold) => {
      thresholds[threshold] = true;
      const scrollEventParams = {
        [key]: {
          event: category,
          value: threshold.toString(),
        },
      };

      window.ym(YA_METRIKA_ID_RECIPE, 'params', scrollEventParams);

      nuxtApp.$sendYandexMetrika({
        level1: eventYm,
        level4: threshold.toString(),
      });
    });
  }

  function onScroll() {
    const contentPercent = viewedContentPercent();

    percentageSendAnalytics(getContentObject(), contentPercent, 'Скролл материала');
  }

  function throttledScroll() {
    return useThrottleFn(onScroll(), 100);
  }

  onMounted(async () => {
    window.addEventListener('scroll', throttledScroll);
    percentageInit('.the-recipe__container');

    if (!recipe) {
      return;
    }

    switch (route.hash) {
      case '#like':
        await reactionsStore.updateLike(recipe.id);
        break;
      case '#dislike':
        await reactionsStore.updateDislike(recipe.id);
        break;
      case '#to-print':
        window.print();
        break;
    }
  });

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', throttledScroll);
  });

  onActivated(() => {
    sendView();
    if (recipe) recipesListWidgetStore.updateCurrentRecipeId(recipe.id);
  });

  onDeactivated(() => {
    watchSend.value = false;
  });

  const getPostDataForFavoritesMethod = (recipe?: FullRecipe | null) => {
    if (!recipe) {
      return null;
    }

    return {
      id: recipe.id,
      title: recipe.title,
      url: route.path,
    };
  };

  const sendView = (): void => {
    if (recipe && !watchSend.value) {
      watchSend.value = true;
      nuxtApp.$viewsApi.incrArticleViewsCount(recipe.id);
    }
  };

  const onUpdateLike = async () => {
    if (!recipe) {
      return;
    }
    await reactionsStore.updateLike(recipe.id);
  };

  const onUpdateDislike = async () => {
    if (!recipe) {
      return;
    }

    await reactionsStore.updateDislike(recipe.id);
  };
  const onCategoryClick = (category: { url: string; title: string }): void => {
    nuxtApp.$sendYandexMetrika({
      level1: 'Клик_Теги',
      level4: category.link,
      level6: category.title,
    });
  };

  const user = computed(() => indexStore.user);
  watch(
    user,
    () => {
      if (recipe) {
        articlesStore.fetchAndSetFavorites({
          post_ids: String(recipe.id),
          per_page: 1,
        });
      }
    },
    { immediate: true },
  );

  watch(
    recipe,
    () => {
      sendView();

      if (recipe) {
        const ids = [recipe.id];
        reactionsStore.fetchReactions(ids);

        if (user.value) {
          articlesStore.fetchAndSetFavorites({
            post_ids: ids.join(),
          });
        }
      }
    },
    { immediate: true },
  );
</script>

<style lang="scss" scoped>
  .the-recipe {
    background: white;
    margin-bottom: 24px;
    border: 1px solid $borderColor;

    @include print {
      @include padding-x(58px);
    }

    &__content-container {
      display: flex;
      flex-direction: column;
      gap: 24px;
      margin: 0px 16px;

      @include tablet {
        margin: 0px 24px;
      }

      @include print {
        margin: 0px;
      }

      :deep() {
        section + .cooking-steps {
          margin-top: 8px;
          @include tablet {
            margin-top: 16px;
          }
        }

        section + .the-recipe__widgets-after-third-block {
          margin-top: 8px;
          @include tablet {
            margin-top: 16px;
          }
        }

        .the-recipe__widgets-after-third-block {
          & + section {
            margin-top: -16px;
            @include tablet {
              margin-top: -8px;
            }
          }
        }

        .lightgrey-box {
          margin: 0;

          @include tablet {
            margin: 0 -24px;
          }
        }

        @include print {
          .wp-block-image {
            display: none;
          }
          p {
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            font-family: $mainFont;
          }
          .base-list__title {
            @include print {
              font-family: $secondFont;
              font-weight: 600;
              font-size: 16px;
              line-height: 24px;
            }
          }
        }
      }
    }

    &__container {
      width: 100%;
      max-width: 640px;

      &_error {
        @include tablet {
          margin-bottom: 24px;
        }
      }

      @include print {
        max-width: 595px;
        @include margin-x(auto);
        margin-top: 0;
      }
    }
    &__print-button {
      margin-bottom: 24px;
    }
    &__cooking-steps,
    &__description,
    &__user-info,
    &__notes,
    &__print-button,
    &__list,
    &__reactions,
    &__categories {
      @include margin-x(16px);
      @include tablet {
        @include margin-x(24px);
      }
      @include print {
        @include margin-x(0);
      }
    }
    &__user-info {
      .lh-user-info__about {
        @include desktop {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }

    &__notes {
      margin-bottom: 16px;

      :deep() {
        .item:nth-last-child(2) {
          padding-bottom: 0px;
          border-bottom: none;

          @include desktop {
            padding-bottom: 12px;
          }
        }
      }
    }

    &__card {
      border-bottom: 1px solid transparent;
      width: calc(100% + 2px);
      margin-left: -1px;
      margin-top: -1px;
    }
    &__description {
      margin-bottom: 16px;

      @include print {
        margin-bottom: 24px;
      }
    }
    &__reactions {
      margin-bottom: 16px;
      padding-left: 8px;
      padding-right: 8px;

      @include tablet {
        margin-bottom: 24px;
      }
    }
    &__list {
      margin-bottom: 24px;
    }
    &__author {
      display: none;
      @include print {
        display: flex;
        align-items: center;
      }
    }

    &__author-avatar {
      @include print {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 8px;
        object-fit: cover;
      }
    }

    &__author-name {
      @include print {
        b {
          @include fontTinyText;
          color: #5c5c5c;
        }
        p {
          @include fontSmallText;
          color: #5c5c5c;
        }
      }
    }
    &__print-footer {
      display: none;
      @include print {
        @include fontSmallText;

        display: block;
        padding: 14px 0 24px;
        margin: 24px 0 0;
        border-top: 1px solid $borderColor;
        page-break-inside: avoid;
      }
    }
    &__print-header {
      display: none;
      @include print {
        display: flex;
        justify-content: space-between;
        padding-top: 16px;
        margin-bottom: 40px;
        &-lh {
          width: 106px;
        }
        &-ve {
          width: 118px;
        }
      }
    }
    &__print-title {
      display: none;
      @include print {
        display: block;
        font-family: $secondFont;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        line-height: 28px;
        margin-bottom: 8px;
      }
    }
    &__container > *:not(.the-recipe),
    &__card,
    &__reactions,
    &__notes,
    &__user-info,
    &__categories,
    &__print-button {
      @include print {
        display: none;
      }
    }

    &__card-placeholder {
      margin-bottom: 0;
    }
    &__hidden-element {
      display: none;
    }

    &__widgets-after-third-block {
      @include print {
        display: none;
      }
    }

    &__categories {
      overflow: hidden;
    }

    &__categories-wrapper {
      margin-left: -8px;
    }

    &__cooking-steps {
      @include print {
        margin-top: 32px;
      }
    }
  }
</style>
